import React from 'react'
import Box from '@material-ui/core/Box'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import { getCapacity, companyOptionLabel } from 'config/helpers/AllocationCapacity'

/*
 * The "Assign to Company" dropdown, shared by the in-lead modal and the bulk
 * allocate modal so the two can never drift apart.
 *
 * Every company actively receiving the product is listed with its live
 * remaining capacity beside it; buyers who are already full stay in the list
 * but are greyed and marked FULL (allocating to them is still possible, but
 * takes an explicit confirmation — see overAllocationWarning).
 */

// Anchor the menu to its select and cap its height, rather than letting it
// render as a full-height list floating over the dialog.
export const MENU_PROPS = {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    PaperProps: { style: { maxHeight: 320 } }
}

export default function CompanySelect(props) {
    const { companies = [], capacityMap, product, value, onChange, disabled } = props

    return (
        <Select
            multiple={false}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            IconComponent={KeyboardArrowDown}
            disabled={disabled}
            MenuProps={MENU_PROPS}
        >
            {companies.map((company) => {
                const capacity = product && product !== 'all'
                    ? getCapacity(capacityMap, company.companyId, product)
                    : null
                return (
                    <MenuItem key={company.companyId} value={company.companyId}>
                        <Box
                            component='span'
                            style={capacity && capacity.isFull ? { opacity: 0.55 } : undefined}
                        >
                            {companyOptionLabel(company.name, capacity)}
                        </Box>
                        {capacity && capacity.isFull &&
                            <Box
                                component='span'
                                marginLeft='0.5rem'
                                fontSize='11px'
                                fontWeight='600'
                                color='#f5365c'
                            >
                                FULL
                            </Box>
                        }
                    </MenuItem>
                )
            })}
        </Select>
    )
}
